/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import {GET_INVOICE, GetRequest, GetResultObject} from "../../../utils/API";

const TYPES = {
  REQUEST_INVOICE: "REQUEST_INVOICE",
  REQUEST_INVOICE_SUCCESS: "REQUEST_INVOICE_SUCCESS",
  REQUEST_INVOICE_FAILED: "REQUEST_INVOICE_FAILED",
  UPDATE_INVOICE_LIST: "UPDATE_INVOICE_LIST",

  REQUEST_DELIVERED: "REQUEST_DELIVERED",
  REQUEST_DELIVERED_SUCCESS: "REQUEST_DELIVERED_SUCCESS",
};


const getInvoices = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_INVOICE,
      payload: {},
    });

    GetRequest(GET_INVOICE, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_INVOICE_SUCCESS,
          payload: {data: datas, ...page},
        });

      })
    })

  }
}

const updateInvoiceList = (payload) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.UPDATE_INVOICE_LIST,
      payload: payload,
    });
  }
}

export default {
  getInvoices,
  updateInvoiceList,
  TYPES,
};
